//V2 changes for utility functions of share want ad

import { capitalizeFirstString } from "./common";

export const getPropertyTextShare = (adDetails) => {
  if (adDetails?.prprtyType === 13) {
    return capitalizeFirstString(adDetails?.prptySubTypesTxt[0]||"");
  } else {
    return capitalizeFirstString(adDetails.prptyTypeTxt||"");
  }
};

export const getAdTypeTextShare = (adType) => {
  if (adType === "BUY") {
    return "Looking to buy";
  } else if (adType === "LTR") {
    return "Looking to rent";
  } else if (adType === "STR") {
    return "Stay in";
  }
};

export const readsAsDemand = (title) =>
  /^\s*(?:(?:buyers?|renters?|clients?|we|i|i'm|we're|i am|we are)\s+)?(?:looking|seeking|need|needs|wanting|wants|in search of)\b/i.test(
    title || "",
  );

export const getPropertyArticle = (propertyText) => {
  // Ensure propertyText is a string, fallback to empty string
  const text = typeof propertyText === "string" ? propertyText.trim() : "";

  if (!text) {
    return ""; // Return an empty string if the input is invalid
  }

  // Words starting with vowel sounds need "an"
  const vowelSounds = ["a", "e", "i", "o", "u"];
  return vowelSounds.includes(text.toLowerCase().charAt(0)) ? "an" : "a";
};

/**
 * Resolves the share link for the want-ad details page.
 *
 * Signed-in users get the server-generated `apiShareUrl` from
 * shareLinksQuery (empty string while it's loading or if it failed). Signed-out
 * visitors never fetch that query (it needs a JWT), so they fall back to the
 * current page's origin + pathname, which is already the canonical public
 * share link for this want-ad — with any query string (e.g. `?tabKey=...`)
 * stripped so shared links don't carry the sharer's own UI state.
 */
export const resolveShareUrl = ({ apiShareUrl, loggedInUserId, href }) => {
  if (loggedInUserId) {
    return apiShareUrl || "";
  }

  if (!href) return "";

  try {
    const url = new URL(href);
    return `${url.origin}${url.pathname}`;
  } catch {
    return "";
  }
};

/**
 * Whether "Share" copies the link straight to the clipboard instead of opening
 * the share modal. Only signed-in, non-restricted users get the shortcut;
 * signed-out visitors have `shouldRestrictAgent === false` too, so they must
 * be excluded explicitly or they never reach the modal.
 */
export const shouldCopyShareLinkDirectly = ({
  loggedInUserId,
  shouldRestrictAgent,
}) => !!loggedInUserId && !shouldRestrictAgent;
